/* global angular */

var EmailRssController = function ($scope, $location) {
    "use strict";


    $scope.$watch(function () {
        return $location.search();
    }, function (params) {
        var params1 = $location.search();
       
        var nUrl = "";
        for (var idxkey in params1) {
            if (idxkey === "sortBy") {
                nUrl = nUrl + "&" + "sortBy=date";
            }

            if (idxkey === "sortOrder") {
                nUrl = nUrl + "&" + "sortOrder=desc";
            }

            if (idxkey !== "sortBy" && idxkey !== "sortOrder") {
				var searchKey = params1[idxkey].replace(/&/g, "%26");
                nUrl = nUrl + "&" + idxkey + "=" + searchKey;
            }
        }
				// strip leading &
        if (nUrl.charAt(0) === '&') {
	        nUrl = nUrl.substr(1);
        }
        $scope.currentLocation = "?" + nUrl;
    });

    $scope.testvar = 'hello';

};
var informaSearchApp = angular.module('informaSearchApp');
informaSearchApp.controller("EmailRssController", ['$scope', '$location', EmailRssController]);
